import Grid from 'Components/Atoms/Grid/Grid';
import UserTemplate from 'Components/Templates/Page/User/UserTemplate';
import {Helmet} from 'react-helmet-async';
import {ROUTES} from 'Services/Route/Route.types';
import Field from 'Components/Organisms/Field/Field';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import {FieldType} from 'Store/FieldManagement/PropTypes';
import Button from 'Components/Atoms/Button/Button';
import {ButtonGroup} from '@atlaskit/button';
import useFetch from 'Api/useFetch';
import {LoadingPage} from 'Pages/Shared/LoadingPage';
import {useEffect, useState} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {useMutation} from 'react-query';
import {API_URL} from 'Store/Shared/Middleware/API/Constants';
import {getAccessTokenFromLocal} from 'Services/helpers';
import {useDispatch} from 'react-redux';
import {NOTIFICATIONTYPE} from 'Store/Notification/ActionTypes';

const ProfilePage = () => {
    const { user: auth0User } = useAuth0();
    const { isLoading, data: user } = useFetch(
        '/api/v2.9/users/me',
        () => {

        }
    );

    const {
        isLoading: isSaving,
        mutateAsync: saveUser
    } = useMutation(
        () => fetch(`${API_URL}/api/v2.9/users/me`, {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${getAccessTokenFromLocal()}`
            },
            body: JSON.stringify({
                email_signature: data.email_signature
            })
        })
    );

    const [data, setData] = useState<any>({
        email: auth0User?.email,
        email_signature: ''
    });

    const dispatch = useDispatch();

    const processSaving = async () => {
        await saveUser();
        dispatch({
            payload: {
                message: 'Je profiel is opgeslagen'
            },
            type: NOTIFICATIONTYPE.SUCCESS
        });
    }

    useEffect(() => {
        if (user?.data?.name) {
            setData((data) => ({
                ...data,
                ...user.data
            }));
        }
    }, [auth0User, user]);

    const handleChange = (key: string) => (value: any) => {
        setData((data) => ({
            ...data,
            [key]: value
        }));
    }

    return <UserTemplate>
        <Helmet>
            <title>{ROUTES.PROFILE.title}</title>
        </Helmet>

        {
            isLoading
            ? <LoadingPage/>
            : <Grid axis='vertical'>
                <FormGroup title={'Naam'}>
                    <Field
                        isEdit={false}
                        value={data?.name}
                        type={FieldType.Text}
                        onChange={() => {}}
                    />
                </FormGroup>
                <FormGroup title={'E-mailaddress'}>
                    <Field
                        isEdit={false}
                        value={data?.email}
                        type={FieldType.Text}
                        onChange={() => {}}
                    />
                </FormGroup>
                <FormGroup title={'E-mail handtekening'}>
                    <Field
                        isEdit={true}
                        value={data?.email_signature || ''}
                        type={FieldType.HTML_Editor}
                        onChange={handleChange('email_signature')}
                    />
                </FormGroup>
                <ButtonGroup>
                    <Button
                        variant={'solid'}
                        color={'primary'}
                        onClick={processSaving}
                        isLoading={isSaving}
                    >
                        Opslaan
                    </Button>
                </ButtonGroup>
            </Grid>
        }
    </UserTemplate>;
}

export default ProfilePage;